import React from "react";
import Faq from "./Faq";
import Features from "./Features";
import Hero from "./Hero";
import CarsHome from "./CarsHome";
import Brandshome from "./BrandsHome";
import AboutUsCard from "./AboutUsCard";

const HomeMain = () => {
  return (
    <>
      <Hero />
      <AboutUsCard />
      <Features />
      <Brandshome />
      <CarsHome />
      <Faq />
    </>
  );
};

export default HomeMain;
